import _toConsumableArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { makeReference, useApolloClient } from '@apollo/client';
import { Loader, Tooltip } from '@infl-ts/ui-advocate-components';
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { nullable } from '@infl-ts/util-io-ts';
import { makeDecodeError } from '@infl-ts/util-make-apollo-decoded';
import { pusher } from '@infl-ts/util-pusher';
import { DisplayQueryError } from '@infl-ts/util-query-errors';
import { useRefetchOnChallengeClose } from '@infl-ts/util-use-challenge-player';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Card, IconButton, Skeleton, Typography } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import crypto from 'crypto';
import * as A from 'fp-ts/Array';
import * as Console from 'fp-ts/Console';
import * as E from 'fp-ts/Either';
import { flow, pipe } from 'fp-ts/function';
import * as T from 'fp-ts/Task';
import * as TE from 'fp-ts/TaskEither';
import * as t from 'io-ts';
import * as L from 'monocle-ts/Lens';
import * as Tr from 'monocle-ts/Traversal';
import { useContext, useEffect } from 'react';
import { Translation, useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import NotificationItem from './notification-item';
import { useNotificationsQuery } from './queries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PusherNotification = t.type({
  id: t.number,
  read: t["boolean"],
  image_url: nullable(t.string),
  created_at: t.string,
  notification_text: t.string,
  notification_title: t.string,
  event_type_code: t.string
});

var sha1Digest = function sha1Digest(message) {
  return crypto.createHash('sha1').update(message).digest('hex');
};

export var subscribe = function subscribe(notificationHandler, userId, t) {
  return pipe(pusher, TE.chainEitherK(function (client) {
    return E.tryCatch(function () {
      return client.subscribe(sha1Digest(userId));
    }, function () {
      return Error(t('Could not subscribe to private user channel'));
    });
  }), TE.chainEitherK(function (userChannel) {
    return E.tryCatch(function () {
      return userChannel.bind('notification', notificationHandler);
    }, function () {
      return Error(t('Could not bind to notifications event'));
    });
  }));
};

var PopupNotification = function PopupNotification(_ref) {
  var onClose = _ref.onClose,
      profile = _ref.profile,
      notification = _ref.notification;
  return /*#__PURE__*/_jsxs(Card, {
    sx: {
      width: 350,
      display: {
        xs: 'none',
        md: 'block'
      }
    },
    "data-element": "Card",
    "data-component": "PopupNotification",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        pl: 2,
        pt: 1,
        pr: 1,
        display: 'flex',
        flexDirection: 'row'
      },
      "data-element": "Box",
      "data-component": "PopupNotification",
      "data-source-file": "index.tsx",
      children: [/*#__PURE__*/_jsx(Translation, {
        "data-element": "Translation",
        "data-component": "PopupNotification",
        "data-source-file": "index.tsx",
        children: function children(t) {
          return /*#__PURE__*/_jsx(Typography, {
            variant: "h4",
            sx: {
              p: 1,
              flex: 1
            },
            children: t('New notification')
          });
        }
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: "Close",
        "data-element": "Tooltip",
        "data-source-file": "index.tsx",
        children: /*#__PURE__*/_jsx(IconButton, {
          onClick: onClose,
          "data-element": "IconButton",
          "data-source-file": "index.tsx",
          children: /*#__PURE__*/_jsx(CloseIcon, {
            "data-element": "CloseIcon",
            "data-source-file": "index.tsx"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(NotificationItem, {
      hoverEffect: true,
      profile: profile,
      notification: notification,
      "data-element": "NotificationItem",
      "data-source-file": "index.tsx"
    })]
  });
};

var NotificationTraySkeleton = function NotificationTraySkeleton() {
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      p: 2,
      pt: 0
    },
    "data-element": "Box",
    "data-component": "NotificationTraySkeleton",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        position: 'relative',
        p: 2,
        pl: 0
      },
      "data-element": "Box",
      "data-component": "NotificationTraySkeleton",
      "data-source-file": "index.tsx",
      children: /*#__PURE__*/_jsx(Skeleton, {
        sx: {
          mr: 2,
          mt: 2
        },
        variant: "circular",
        width: 40,
        height: 40,
        "data-element": "Skeleton",
        "data-component": "NotificationTraySkeleton",
        "data-source-file": "index.tsx"
      })
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        width: '100%'
      },
      "data-element": "Box",
      "data-source-file": "index.tsx",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        width: "80%",
        height: 24,
        "data-element": "Skeleton",
        "data-source-file": "index.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        width: "40%",
        height: 24,
        "data-element": "Skeleton",
        "data-source-file": "index.tsx"
      })]
    })]
  });
};

var TrayWrapper = function TrayWrapper(_ref2) {
  var _children = _ref2.children;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "TrayWrapper",
    "data-source-file": "index.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsxs(Box, {
        id: "NotificationTray",
        sx: {
          width: {
            xs: '100vw',
            sm: '300px',
            md: '360px'
          },
          maxHeight: '450px',
          overflowY: 'scroll',
          boxShadow: 3,
          pt: 2
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mx: 2,
            mb: 2
          },
          children: t('Notifications')
        }), _children]
      });
    }
  });
};

export var PureNotificationTray = function PureNotificationTray(_ref3) {
  var result = _ref3.result,
      fetchMore = _ref3.fetchMore,
      profile = _ref3.profile,
      t = _ref3.t;
  return pipe(result, DE.squash(function () {
    return /*#__PURE__*/_jsxs(TrayWrapper, {
      children: [/*#__PURE__*/_jsx(NotificationTraySkeleton, {}), /*#__PURE__*/_jsx(NotificationTraySkeleton, {}), /*#__PURE__*/_jsx(NotificationTraySkeleton, {})]
    });
  }, function (err, refreshing) {
    return /*#__PURE__*/_jsx(DisplayQueryError, {
      err: err,
      refreshing: refreshing,
      message: "Could not load notifications",
      children: function children() {
        return /*#__PURE__*/_jsx(TrayWrapper, {
          children: /*#__PURE__*/_jsx(Typography, {
            sx: {
              m: 2,
              textAlign: 'center'
            },
            children: t('Unable to load notifications')
          })
        });
      }
    });
  }, function (_ref4) {
    var _pageInfo$hasNextPage;

    var _ref4$notifications = _ref4.notifications,
        edges = _ref4$notifications.edges,
        pageInfo = _ref4$notifications.pageInfo;

    if (edges.length === 0) {
      return /*#__PURE__*/_jsx(TrayWrapper, {
        children: /*#__PURE__*/_jsx(Typography, {
          sx: {
            m: 2,
            textAlign: 'center'
          },
          children: t('You have no notifications')
        })
      });
    }

    return /*#__PURE__*/_jsx(TrayWrapper, {
      children: /*#__PURE__*/_jsx(InfiniteScroll, {
        scrollableTarget: 'NotificationTray',
        dataLength: edges.length,
        next: function next() {
          void fetchMore({
            variables: {
              last: 5,
              before: edges[edges.length - 1].cursor
            }
          });
        },
        hasMore: (_pageInfo$hasNextPage = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage) !== null && _pageInfo$hasNextPage !== void 0 ? _pageInfo$hasNextPage : false,
        loader: /*#__PURE__*/_jsx(Loader, {}),
        children: pipe(edges, A.map(function (notification) {
          return /*#__PURE__*/_jsx(NotificationItem, {
            profile: profile,
            notification: notification.node
          }, notification.node.id);
        }))
      })
    });
  }));
};

var convertPusherNotification = function convertPusherNotification(_ref5) {
  var id = _ref5.id,
      read = _ref5.read,
      image_url = _ref5.image_url,
      created_at = _ref5.created_at,
      notification_title = _ref5.notification_title,
      notification_text = _ref5.notification_text,
      event_type_code = _ref5.event_type_code;
  return {
    id: id.toString(),
    unread: !read,
    iconUrl: image_url,
    createdAt: created_at,
    title: notification_title,
    description: notification_text,
    eventType: event_type_code,
    node: null
  };
};

var incrementNotificationsCursors = pipe(L.id(), L.prop('notifications'), L.prop('edges'), L.traverse(A.Traversable), Tr.prop('cursor'), Tr.modify(function (cursor) {
  return String(parseInt(cursor, 10) + 1);
}));

var shouldShowPopup = function shouldShowPopup(notification) {
  return ['advanced_level', 'reward_available', 'earned_badge'].includes(notification.eventType);
};

var useProps = function useProps(_ref6) {
  var profile = _ref6.profile;

  var _useNotificationsQuer = useNotificationsQuery({
    variables: {
      last: 5
    }
  }),
      result = _useNotificationsQuer.result,
      fetchMore = _useNotificationsQuer.fetchMore;

  var apolloClient = useApolloClient();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  useEffect(function () {
    void pipe(subscribe(flow(function (data) {
      return PusherNotification.decode(data);
    }, E.mapLeft(makeDecodeError), E.map(convertPusherNotification), E.matchW(console.error, function (notification) {
      var _notifications, _ref7;

      var notificationCache = apolloClient.readQuery({
        query: useNotificationsQuery.document
      });
      var notifications = (_notifications = (_ref7 = notificationCache !== null && notificationCache !== void 0 && notificationCache.notifications ? incrementNotificationsCursors(notificationCache) : null) === null || _ref7 === void 0 ? void 0 : _ref7.notifications) !== null && _notifications !== void 0 ? _notifications : {
        edges: [],
        pageInfo: {
          hasNextPage: false
        }
      };
      apolloClient.cache.writeQuery({
        query: useNotificationsQuery.document,
        data: {
          notifications: _objectSpread(_objectSpread({}, notifications), {}, {
            edges: [{
              cursor: '1',
              node: notification
            }].concat(_toConsumableArray(notifications.edges))
          })
        },
        variables: {
          override: true
        }
      });

      if (shouldShowPopup(notification)) {
        showAlert({
          component: function component(onClose) {
            return /*#__PURE__*/_jsx(PopupNotification, {
              onClose: onClose,
              profile: profile,
              notification: notification
            });
          },
          duration: 'long'
        });
      }

      apolloClient.cache.evict({
        id: apolloClient.cache.identify(makeReference('ROOT_QUERY')),
        fieldName: 'unreadNotifications'
      });
      apolloClient.cache.gc();
    })), profile.id, t), TE.getOrElseW(function (err) {
      return T.fromIO(Console.error('Could not subscribe to notifications: ' + JSON.stringify(err)));
    }))();
  }, []);
  useRefetchOnChallengeClose([useNotificationsQuery.document]);
  return {
    result: result,
    fetchMore: fetchMore,
    profile: profile,
    t: t
  };
};

export default Object.assign(flow(useProps, PureNotificationTray), {
  displayName: 'NotificationTray'
});